module.exports = __webpack_public_path__ + "static/resume(2019-02-26)-fdcbbc05a2cd97c40f07a3388e871499.pdf";